import styled from "@emotion/styled";
import { BLUE_LIGHT, OLD_BLUE } from "src/constants/colors";

export const Container = styled.div`
  position: relative;
`;

export const HeaderContainer = styled.div`
  background-color: transparent;
  border: 0;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 30px;
  min-height: 30px;
  padding: 0px 8px;
`;

export const List = styled.div`
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(228, 231, 236, 1);
  border-radius: 12px;
  box-shadow:
    0px 2px 8px rgba(0, 0, 0, 0.06),
    0px 16px 64px -12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;
  position: absolute;
  bottom: 32px;
  right: 0px;
`;

export const ListItem = styled.div`
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 34px;
  padding: 8px;
  width: 82px;
  cursor: pointer;

  &:hover {
    background-color: ${BLUE_LIGHT};
    color: ${OLD_BLUE};
  }
`;
